<template>
	<svg :id="`map-chart-${mapChartNum}`" width="100%" height="100%" viewBox="0 0 300 200">
			<g>
				<path 
				v-for="(region, index) in data" 
						:key="region.id" 
						:id="region.id" 
						:value="region.name"
						:d=region.d
						@click=chooseRegion(index)
						v-tippy="{ content: regionTippy(region), theme: 'light', delay: [100, 500], position: 'top', arrow: false, animation: 'scale'}"
						class="region" 
						:style="{'stroke-width': '0.5', 'fill': regionFill(region), 'z-index': '100', 'fill-opacity': regionOpacity(region), 'stroke': 'grey', 'stroke-opacity': '1'}">
				</path>
			</g>
			<g v-for="(range, index) in percentRange" :key="range" >
				<rect v-if="range !== 'н/д'" width="14" height="8" :x="0 + 15 * index" y="175"
					:style="{'fill': `rgb(${color})`, 'fill-opacity': `${range / 100}`, 'stroke': 'lightgrey', 'stroke-width': '0.5'}">
				</rect>
				<rect v-else width="14" height="8" :x="0 + 15 * index" y="175"
					:style="{'fill': `lightgrey`, 'fill-opacity': '1', 'stroke': 'lightgrey', 'stroke-width': '0.5'}">
				</rect>
			</g>
			<g v-for="(range, index) in percentRange" :key="range">
				<text :x="0 + 15 * index" y="190" style="fill: gray; font-size: 7px;">
					{{ range }}
			</text>
			</g>
	</svg>
</template>
  
<script>
import { directive } from 'vue-tippy'
import 'tippy.js/themes/material.css';
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/scale.css';
const regionCodesNotSurveyed = ['27', '28', '13', '7', '22', '19', '10']

export default {
	name: 'MapBase',
	components: {
	},
	directives: {
		tippy: directive,
	},
	props: {
			mapChartNum: {
				Number,
			},
			color: {
				String,
				default: () => '0, 0, 0'
			},
			data: {
					Object,
					default: () => {}
			}
	},
	data() {
		return {
		}
	},
	computed: {
		percentRange() {
			const percentages = this.data.map(({ percentage }) => percentage);
			const maxPercentage = Math.max(...percentages.filter(isFinite));
			const minPercentage = Math.min(...percentages.filter(isFinite));
			const percentRange = []
			for (let i = Math.floor(minPercentage / 10) * 10; i <= Math.floor(maxPercentage / 10) * 10 + 10; i += 10) {
				percentRange.push(i)
			}
			percentRange.push('н/д')
			return percentRange;
		}
	},
	methods: {
		regionOpacity(region) {
			return !regionCodesNotSurveyed.includes(region.code) ? ((region.percentage / 100).toFixed(1)) : 1
		},
		regionFill(region) {
			return region.percentage ? `rgba(${this.color})` : 'lightgrey'
		},
		regionTippy(region) {
			region.percentage ? region.percentage : region.percentage = 0
			return !regionCodesNotSurveyed.includes(region.code) ? `${region.name}, ${(region.percentage).toFixed()}%` : `${region.name}, немає даних`
		},
		chooseRegion(region) {
			this.$emit('regionSelected', region)
		}
	},
}
</script>

<style lang="sass">
.region 
	&:focus
		outline: none


</style>
